import { ReactNode } from "react";

import { AppFooter } from "@/components/AppFooter";
import { useUsersnapLmsPlatform } from "@/hooks/useUsersnapLmsPlatform";
import { usePage } from "@inertiajs/react";

import { Flex } from "@chakra-ui/react";

import ParentsPortalNav from "@components/ParentsPortalNav/ParentsPortalNav.tsx";

interface PropTypes {
    children: ReactNode;
    backgroundColor?: string;
    maxW?: string | number;
    isEnableMaxH?: boolean;
    showNav?: boolean;
}

const ParentPortalLayout = ({
    children,
    backgroundColor = "base.200",
    maxW = "1280px",
    isEnableMaxH = false,
    showNav = true
}: PropTypes) => {
    // version text being passed from backend...
    const { versionText } = usePage().props;

    // Send LMS platform context to Usersnap for feedback tagging
    useUsersnapLmsPlatform();

    const getVersionText = (): string => {
        return versionText as string;
    };

    return (
        <Flex
            id="portal-layout"
            direction="column"
            backgroundColor={backgroundColor}
            minH="100dvh"
            maxH={{ base: "none", md: isEnableMaxH ? "100dvh" : "none" }}
            data-testid="parent-portal-layout"
        >
            {showNav && <ParentsPortalNav />}
            <Flex
                direction="column"
                maxW={maxW}
                width="100%"
                mx="auto"
                flex={1}
                position="relative"
            >
                {children}
            </Flex>
            {versionText !== null && (
                <AppFooter versionText={getVersionText()} />
            )}
        </Flex>
    );
};

export default ParentPortalLayout;
